import React, { useEffect, useState } from "react";
import Header from "./../../Components/Header/Header";
import "./PaymentWithUPI.css";
import { CiBank } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import useAxiosHelper from "./../../Common/AxiosHelper";
import { ApiPaths } from "./../../Config/ApiPath";
import { BsQrCodeScan } from "react-icons/bs";
import { FaMoneyCheckDollar } from "react-icons/fa6";
import { FaReceipt } from "react-icons/fa";
import RotateLoader from "./../../Components/RotateLoader/RotateLoader";
import ReactDOM from "react-dom";
import QRCode from "react-qr-code";
import CopyFromtag from "../../Common/CopyFromtag";

import { toastFailed, toastSuccess } from "../../Config/BasicInfo";
import { FiCopy } from "react-icons/fi";
import Change from "../../Common/StringToSub";
const PaymentWithUPI = () => {
  const { AxiosGet } = useAxiosHelper();
  const navigate = useNavigate();
  const [upiDetailsData, setUpiDetailsData] = useState({});
  const [payableAmount, setPayableAmount] = useState();
  const [fetchDone, setFetchDone] = useState(false);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (!fetchDone) {
      FetchBankDetails();
      setFetchDone(true);
    }
  }, [fetchDone]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const amount = urlParams.get("amount");
    setPayableAmount(amount);
  }, []);

  const FetchBankDetails = async () => {
    try {
      setLoading(true);
      const res = await AxiosGet(ApiPaths.getPaymentMethod);
      // console.log("222222222", res);
      toastSuccess(res?.data?.message);
      setUpiDetailsData(res?.activeOptions?.web3?.chains?.[0] || {});
    } catch (e) {
      toastFailed(e?.message);
      // console.error("Error fetching upi details:", e);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="dashboard">
      <section className="mainContent pt-4">
        <div className="paymentWithUPIContent">
          <div id="paymentWithUpiAmountDiv">
            <p>Amount</p>
            <p>{payableAmount}</p>
          </div>

          <div id="paymentWithUPIContentQRDiv">
            <h1>Scan QR Code To Pay</h1>
            {loading == true ? (
              <RotateLoader />
            ) : upiDetailsData?.address != null ? (
              <div>
                <QRCode
                  size={256}
                  style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                  value={upiDetailsData?.address}
                  viewBox={`0 0 256 256`}
                />
              </div>
            ) : (
              ""
            )}
            <p
              style={{
                color: "var(--textHeading)",
                margin: "0",
                marginTop: "10px",
              }}
            >
              {upiDetailsData?.chain}
            </p>
            <p>Don't use the same QR code to pay multiple times</p>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-around",
              gap: "10px",
            }}
          >
            <div
              style={{
                padding: "10px",
                margin: "20px 0px",
                background: "#3f3e3e7d",
                width: "100%",
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-around",
                gap: "10px",
              }}
              className="btnPrimary"
            >
              <p style={{ margin: "10px", width: "90%", textAlign: "center" }}>
                {Change(upiDetailsData?.address)}
              </p>
              <p
                id="web3address"
                style={{ margin: "10px", width: "90%", textAlign: "center" }}
              >
                {upiDetailsData?.address}
              </p>
            </div>
            <i onClick={() => CopyFromtag("web3address")}>
              <FiCopy color="#fff" />
            </i>
          </div>
          <div id="paymentWithUPIContentProcess">
            <div>
              <i>
                <BsQrCodeScan />
              </i>
              <p>Scan the QR code or copy the provided Web3.</p>
            </div>

            <div>
              <i style={{ fontSize: "22px" }}>
                <FaReceipt />
              </i>
              <p>
                Enter the payment amount. Then, review the payment details and
                complete the transaction.
              </p>
            </div>
          </div>
          <h5>If you have completed your payment. Please share proof here</h5>

          <button
            className="btnPrimary"
            onClick={() =>
              navigate("/payment-proof", {
                state: { myData: JSON.stringify(payableAmount) },
              })
            }
          >
            Submit
          </button>
        </div>
      </section>
    </div>
  );
};

export default PaymentWithUPI;
